import {
  Box,
  Button,
  Divider,
  InputBase,
  Typography,
  InputAdornment,
  IconButton,
  Checkbox,
  CircularProgress,
  Paper,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Stack,
  styled,
  stepConnectorClasses,
  StepConnector,
  FormControl,
  MenuItem,
  Select,
  Autocomplete,
  FormControlLabel,
  Tooltip,
  RadioGroup,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { CalculateProductPrice } from "../utils/price";
import  indianNumberFormat  from "../components/numberFormat";
import { DatePicker } from "@mui/x-date-pickers";
import VerifiedIcon from "@mui/icons-material/Verified";
import InfoIcon from "@mui/icons-material/Info";
import { TranslateText } from "../utils/googletranslator";
import {
  updateEmail,
  updateMobile,
  updateWhatsapp,
  updateFirstName,
  updateLastName,
  updatePassword,
  updateOtpCheck,
  updateMemberResponse,
  updateRole,
  updateId,
  updateProfile,
  updateUserData,
  updateUserName,
  updateCountry,
  updateIdentityNumber,
  updateisVerifyTick,
  updateDob,
  updateRefID,
  updateMembership,
  updateConrtol
} from "../redux/user_reducer";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Link, useNavigate,useSearchParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import mayi_logo from "../assets/mayi_global_dark.png";
import background from "../assets/Background.webp";
import CustomAxios from "../utils/CustomAxios";
import { useMediaQuery } from "react-responsive";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
// import PhoneInput from "react-phone-number-input";
import axios from "axios";
import { green } from "@mui/material/colors";
import OtpSignPin from "../components/otp_verify_signup";
import ConfirmationDialog from "../components/ConfirmationDialog";
import MessageBar from "../modules/messageBar";
import { countries as countries_json } from "../countries";
import { getCountryPhoneLength } from "../utils/countryPhoneRules";
import {
  buildPhonePayload,
  normalizePhoneDigits,
  validateLocalMobile,
} from "../utils/phoneNumber";
import {
  updateSnackBarMessage,
  updateSnackBarSeverity,
  updateSnackBarOpen,
} from "../redux/snackbar";
import OtpVerifyOption from "../components/otp_verify_option";

/** sessionStorage key for signup terms acceptance before OTP step */
const SIGNUP_OTP_TERMS_KEY = "mayiiq_signup_otp_terms_accepted";

export const inputStyles = {
  inputBase: {
    border: "1px solid",
    borderColor: "grey.400",
    maxWidth: { xs: "100%", sm: "100%" },
    width: "100%",
    borderRadius: "5px",
    height: "48px",
    fontSize: "14px",
    padding: "14px",
    color: "grey.600",
  },
  Select: {
    maxWidth: { xs: "100%", sm: "100%" },
    width: "100%",
    borderRadius: "5px",
    height: "48px",
    fontSize: "14px",
    color: "grey.600",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid",
      borderColor: "grey.400",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey.400",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid",
      borderColor: "grey.400",
    },
  },
  PhoneInput: {
    border: "1px solid",
    borderColor: "grey.400",
    maxWidth: { xs: "100%", sm: "100%" },
    width: "100%",
    borderRadius: "5px",
    height: "48px",
    fontSize: "14px",
    padding: "14px",
    color: "grey.600",
  },
  label: {
    marginBottom: "8px",
    fontWeight: 400,
    fontSize: "14px",
    color: "grey.900",
    textAlign: "left",
  },
  terms: { fontWeight: 400, fontSize: "14px", whiteSpace: "pre-wrap" },
  paper: {
    padding: { sm: "32px", xs: "32px" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    bgcolor: "#fff",
    height: "150px",
    width: { sm: "50%", xs: "100%" },
  },
  button: {
    height: "3rem",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "14px",
    maxWidth: "100%",
    "&:hover": { bgcolor: "primary.light", color: "primary.contrastText" },
    borderRadius: "5px",
    "&:focus": { border: "0px solid white" },
  },
  heading: {},
  logo: { width: "100px", cursor: "pointer" },
  subHeading: { marginTop: "12px", fontWeight: "700", fontSize: "14px" },
  content: {
    marginBottom: "16px",
    fontWeight: "400",
    fontSize: "14px",
    textAlign: "center",
  },
  selectPaper: {
    maxHeight: "10px",
    overflowY: "auto",
  },
};

const normalizeReferralCode = (value = "") => String(value || "").trim();

const getReferralCodeError = (value = "") => {
  const normalizedValue = normalizeReferralCode(value);

  if (!normalizedValue || ["undefined", "null"].includes(normalizedValue.toLowerCase())) {
    return "Please use a valid referral link";
  }

  return "";
};

const SignupStepperForm = () => {
  const [searchParams]=useSearchParams()
  const dispatch = useDispatch();
  const first_name = useSelector((state) => state.user.first_name);
  const last_name = useSelector((state) => state.user.last_name);
  const email = useSelector((state) => state.user.email);
  const password = useSelector((state) => state.user.password);
  const identityNumber = useSelector((state) => state.user.identityNumber);
  const Dob = useSelector((state) => state.user.dob);
  const selectedSize = useSelector((state) => state.user.selectedSize || "");
  const currentQuery=searchParams.get("code")||""
  const packageSelection = useSelector(
    (state) => state.user.packageSelection || ""
  );
  const referredBy = useSelector((state) => state.user.referredBy || "");
  const [openInfo, setOpenInfo] = useState(false);
  const [open, setOpen] = useState(false);
  const tooltipRef = useRef(null);
  const [showPassword, setShowPassword] = useState({
    password: false,
    con_password: false,
  });
  useEffect(()=>{
    dispatch(
      updateUserData({
        type: "referredBy",
        data: normalizeReferralCode(currentQuery),
      })
    )
  },[currentQuery, dispatch])
  const [referralCode, setReferralCode] = useState("");
  const [response, setResponse] = useState("");
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const [agree, setAgree] = useState(false);
  const [errors, setErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [mobileNo, setMobileNo] = useState("");
  const [numberLength, setNumberLength] = useState(15);
  const [otpModal, setOtpmodal] = useState({ value: false, type: "" });
  const [checked, setChecked] = useState(false);
  // const [isVerified, setIsVerified] = useState(false);
  const [pendingCountry, setPendingCountry] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // const [refs_id, setRefId] = useState("");
  const [platform,setPlatform]=useState("web")
  const refs_id=useSelector(state=>state.user.ref_id)
  const [verifyError, setVerifyError] = useState("");
  const [isReferralValidating, setIsReferralValidating] = useState(false);
  const [validatedReferralCode, setValidatedReferralCode] = useState("");
  const sizeOptions = [
    { value: "package", label: "Packages" },
    // { value: "combo", label: "Combos" },
  ];
  const [packageOptions, setPackageOptions] = useState([]);
  const [switchOTP, setSwitchOTP] = useState(false);
  const [signupOtpRequested, setSignupOtpRequested] = useState(false);
  const [signupTermsAccepted, setSignupTermsAccepted] = useState(() => {
    try {
      return sessionStorage.getItem(SIGNUP_OTP_TERMS_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  // const isVerify = useSelector((state) => state.isVerifyTick);
  const queryParameters = new URLSearchParams(window.location.search);
  const clientId =
    "521447616048-relr5c80sac2rudgmfub8kantovfc5pe.apps.googleusercontent.com"; // Replace with your actual client ID
  const authtoken = localStorage.getItem("authtoken");
  const user_data = useSelector((state) => state.user);
  const member=useSelector((state)=>state.user.member)
  const [openMember, setOpenMember] = useState(false);
  const [openNonMember, setOpenNonMember] = useState(false);
  useEffect(() => {
    if (authtoken) {
      navigate("/");
    }
  }, []);
  const fetchCountries = async () => {
    try {
      const response = { data: countries_json };
      return response.data
        .map((country) => ({
          value: country?.cca2,
          label: country?.name?.common,
          dialCode: `${country?.idd?.root || ""}${country?.idd?.suffixes?.[0] || ""}`,
          flag: country?.flags?.png,
          numberLength: getCountryPhoneLength(country?.cca2),
        }))
        .filter((country) => country.value && country.label && country.dialCode);
    } catch (error) {
      return [];
    }
  };
  useEffect(() => {
    let isMounted = true;

    const initializeCountries = async () => {
      const countryOptions = await fetchCountries();
      if (!isMounted) {
        return;
      }

      setCountries(countryOptions);
      const india = countryOptions.find((country) => country.value === "IN") || countryOptions[0] || null;
      setSelectedCountry(india);
      setNumberLength(india?.numberLength || 15);
      setMobileNo(india ? "" : "");
    };

    initializeCountries();

    return () => {
      isMounted = false;
    };
  }, []);
  useEffect(() => {
    if (selectedCountry?.value != "IN") {
      setChecked(true);
    } else {
      setChecked(false);
    }
    // console.log(selectedCountry);
  }, [selectedCountry]);

  const setReferralError = (message) => {
    setValidatedReferralCode("");
    setResponse(message);
    setErrors((prev) => ({
      ...prev,
      referredBy: message,
    }));
  };

  const validateReferralCode = async (referralValue, forceRefresh = false) => {
    const normalizedReferral = normalizeReferralCode(referralValue);
    const localError = getReferralCodeError(normalizedReferral);

    if (localError) {
      setReferralError(localError);
      return { ok: false, message: localError };
    }

    if (!forceRefresh && validatedReferralCode === normalizedReferral) {
      setResponse("");
      setErrors((prev) => ({
        ...prev,
        referredBy: "",
      }));
      return { ok: true, message: "" };
    }

    setIsReferralValidating(true);

    try {
      const { data } = await CustomAxios.post("validate-signup-referral/", {
        referral: normalizedReferral,
      });

      if (data?.is_valid) {
        setValidatedReferralCode(normalizedReferral);
        setResponse("");
        setErrors((prev) => ({
          ...prev,
          referredBy: "",
        }));
        return { ok: true, message: "" };
      }

      const message = data?.message || "Please enter a valid referral code";
      setReferralError(message);
      return { ok: false, message };
    } catch (error) {
      const message = "We could not validate the referral code right now";
      setReferralError(message);
      return { ok: false, message };
    } finally {
      setIsReferralValidating(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const normalizedReferral = normalizeReferralCode(currentQuery);
    const localError = getReferralCodeError(normalizedReferral);

    if (localError) {
      setReferralError(localError);
      return undefined;
    }

    const validateOnLoad = async () => {
      setIsReferralValidating(true);

      try {
        const { data } = await CustomAxios.post("validate-signup-referral/", {
          referral: normalizedReferral,
        });

        if (!isMounted) {
          return;
        }

        if (data?.is_valid) {
          setValidatedReferralCode(normalizedReferral);
          setResponse("");
          setErrors((prev) => ({
            ...prev,
            referredBy: "",
          }));
          return;
        }

        setValidatedReferralCode("");
        setResponse(data?.message || "Please enter a valid referral code");
        setErrors((prev) => ({
          ...prev,
          referredBy: data?.message || "Please enter a valid referral code",
        }));
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setValidatedReferralCode("");
        setResponse("We could not validate the referral code right now");
        setErrors((prev) => ({
          ...prev,
          referredBy: "We could not validate the referral code right now",
        }));
      } finally {
        if (isMounted) {
          setIsReferralValidating(false);
        }
      }
    };

    validateOnLoad();

    return () => {
      isMounted = false;
    };
  }, [currentQuery]);

  const handleSummit = async () => {
    const formData = {
      email: email,
      first_name: first_name,
      last_name: last_name,
      referralCode: referredBy,
      mobile_no: user_data.mobile_no,
      selectedCountry: selectedCountry,
      selectedSize: selectedSize,
      packageSelection: packageSelection,
      // referredBy: referredBy,
    };

    const validate = validateForm(formData);
    if (validate) {
      const referralResult = await validateReferralCode(referredBy);
      if (!referralResult.ok) {
        return;
      }

      setResponse("");
      setSignupOtpRequested(false);
      setActiveStep(2);
    }
  };

  const handleSignupTermsAgree = () => {
    try {
      sessionStorage.setItem(SIGNUP_OTP_TERMS_KEY, "1");
    } catch {
      /* ignore */
    }
    setSignupTermsAccepted(true);
    setTermsModalOpen(false);
  };

  useEffect(() => {
    GetPlans();
  }, [selectedSize]);
  const GetPlans = async () => {
    const response = await CustomAxios.get(`plans/`);
    const plans = Array.isArray(response.data) ? response.data : [];
    setPackageOptions(plans);
    if (
      packageSelection &&
      (
        !plans.length ||
        String(packageSelection) !== String(plans[0].id)
      )
    ) {
      dispatch(
        updateUserData({
          type: "packageSelection",
          data: "",
        })
      );
    }
  }
  const handleCountryChange = (event, value) => {
    const selectedOption = countries.find(
      (country) => country.value === value?.value
    );
    const hasDetails = user_data.mobile_no || identityNumber;

    if (selectedCountry?.value !== selectedOption?.value) {
      if (hasDetails) {
        setSelectedCountry(selectedOption || null);
        setIsDialogOpen(true);
      } else {
        setSelectedCountry(selectedOption || null);
      }
    }
  };

  const handleConfirm = () => {
    // Reset the form data when confirmed
    setSelectedCountry(pendingCountry || null);
    setMobileNo("");
    dispatch(updateIdentityNumber(""));
    dispatch(updateMobile(""));
    dispatch(updateisVerifyTick(false));

    // setIsVerified(false);
    setIsDialogOpen(false);
  };

  const handleCancel = () => {
    // Close the dialog without making any changes
    setIsDialogOpen(false);
  };

  const handleInfoClick = () => {
    setOpenInfo((prev) => !prev);
  };

  const handleCloseInfo = () => {
    setOpenInfo(false);
  };

  useEffect(() => {
    if (selectedCountry) {
      setNumberLength(selectedCountry.numberLength);
    }
  }, [selectedCountry]);

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const id = useSelector((state) => state.user.id);
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const userId = useSelector((state) => state.user.id);

  useEffect(() => {
    setReferralCode(queryParameters.get('code'));
    if (queryParameters.get('code')){
      setPlatform('referred')
    }
    else if(queryParameters.get('signup_via')){
      localStorage.setItem('signup_via',queryParameters.get('signup_via'))
      navigate('/products')
      
      // setPlatform(queryParameters.get('signup_via'))
    }
    if(localStorage.getItem('signup_via')){
      // console.log(localStorage.getItem('signup_via'))
      setPlatform(localStorage.getItem('signup_via'))
    }
    
  }, []);
  useEffect(() => {
    dispatch(updatePassword(""));
    dispatch(updateUserName(""));
    dispatch(updateFirstName(""));
    dispatch(updateLastName(""));
    dispatch(updateEmail(""));
    dispatch(updateMobile(""));
    dispatch(updateId(""));
    dispatch(updateCountry(""));
    dispatch(updateIdentityNumber(""));
    dispatch(updateOtpCheck("signup"));
  }, []);
  const signup = async (otpDeliveryMethod = "mobile") => {
    setIsloading(true);
    setResponse("");
    const phoneResult = buildPhonePayload({
      mobile: user_data.mobile_no,
      dialcode:
        selectedCountry?.value == "US" ? "+1" : selectedCountry?.dialCode,
      countryCode: selectedCountry?.value,
      maxLength: selectedCountry?.numberLength || 15,
    });

    if (!phoneResult.ok) {
      setIsloading(false);
      setErrors((prev) => ({
        ...prev,
        mobile_no: phoneResult.error,
      }));
      return { ok: false, message: phoneResult.error };
    }

    const payload = {
      email: email,
      first_name: first_name,
      last_name: last_name,
      referralcode: referredBy,
      isactive: false,
      member:"member",
      
      mobileno: phoneResult.payload.mobileno,
      
      country: selectedCountry?.label,
      dialcode: phoneResult.payload.dialcode,
      whatsapp: checked ? true : false,
      selectedSize: selectedSize,
      packageSelection: packageSelection,
      referralCode: referredBy,
      verificationType: otpDeliveryMethod,
    };
    // console.log("=====================================", payload);
    try {
      const { data } = await CustomAxios.post(`signup/`, payload);
      setIsloading(false);
      localStorage.setItem("user", JSON.stringify(data));
      localStorage.setItem("isVerified", false);
      localStorage.setItem("package", packageSelection);
      if (data.signup_session_id) {
        localStorage.setItem("signupSessionId", data.signup_session_id);
      }

      if (data.message === "Registration Successful!") {
        dispatch(updatePassword(""));
        dispatch(updateUserName(""));
        dispatch(updateEmail(data.email));
        dispatch(updateMobile(data.mobileno));
        dispatch(updateId(data.signup_session_id || data.user_id));
        dispatch(updateWhatsapp(checked ? true : false));
        dispatch(updateCountry(selectedCountry?.label || ""));
        dispatch(updateIdentityNumber(""));
        dispatch(updateOtpCheck("signup"));
        setErrors({});
        setSignupOtpRequested(true);
        return { ok: true, data };
      }

      setResponse(data.message);
      return {
        ok: false,
        message: data.message || "We could not complete signup. Please try again.",
      };
    } catch (error) {
      setIsloading(false);
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "We could not complete signup. Please try again.";
      setResponse(message);
      return { ok: false, message };
    }
  };


  const handleTogglePasswordVisibility = (val) => {
    if (val === "con") {
      setShowPassword((prevShowPassword) => {
        return {
          ...prevShowPassword,
          con_password: !prevShowPassword.con_password,
        };
      });
    } else {
      setShowPassword((prevShowPassword) => {
        return {
          ...prevShowPassword,
          password: !prevShowPassword.password,
        };
      });
    }
  };

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const isTablet = useMediaQuery({ maxWidth: 900, minWidth: 600 });
  const isLaptop = useMediaQuery({ query: "(min-width: 900px)" });

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };
  const memberTooltip = () => {
    setOpenMember(true);
  };
  const memberTooltipClose = () => {
    setOpenMember(false);
  };
  const nonMemberTooltip = () => {
    setOpenNonMember(true);
  };
  const nonMemberTooltipClose = () => {
    setOpenNonMember(false);
  };

  const handleVerifyClick = async () => {
    // console.log(selectedCountry, Dob);

    const currentDate = new Date();
    const selectedDob = new Date(Dob);
    if (!selectedCountry) {
      setErrors((prev) => ({
        ...prev,
        selectedCountry: "Please select a country",
      }));
      return;
    }

    // Check if the selected country is not India and DOB is not provided
    if (selectedCountry?.value !== "IN" && !Dob) {
      setErrors((prev) => ({
        ...prev,
        Dob: "Please enter your Date of Birth",
      }));
      return;
    } else {
      // Check if the DOB is in the future
      if (selectedDob > currentDate) {
        setErrors((prev) => ({
          ...prev,
          Dob: "Date of Birth cannot be in the future. Please select a valid date.",
        }));
        return;
      } else {
        // Clear the DOB error if the selected country is India or DOB is valid
        setErrors((prev) => ({
          ...prev,
          Dob: "", // Clear the error message if it exists
        }));
      }
    }

    // Check if identityNumber is provided
    if (!identityNumber.trim()) {
      if (selectedCountry?.value === "IN") {
        setErrors((prev) => ({
          ...prev,
          identityNumber: "Please enter the Aadhaar number",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          identityNumber: "Please enter the Passport number",
        }));
      }
      return;
    }

    try {
      setIsLoading(true);
      let payload = {};
      if (selectedCountry?.value === "IN") {
        payload = {
          id: userId,
          aadhaar_number: identityNumber,
          mobileNumber: user_data.mobile_no,
          verifyOtpFor: "aadhaar",
        };
      } else {
        payload = {
          id: userId,
          identity_number: identityNumber,
          mobileNumber: user_data.mobile_no,
          dob: Dob,
          verifyOtpFor: "passport",
        };
      }

      // console.log("Payload for verification:", payload);
      const response = await CustomAxios.post("verifykyc/", payload);
      // console.log(response);

      if (response.data.status === "SUCCESS") {
        setErrors((prev) => ({ ...prev, identityNumber: "" }));
        // setRefId(response.data.ref_id);
        dispatch(updateRefID (response.data.ref_id));

        if (payload.verifyOtpFor === "aadhaar") {
          setOtpmodal({
            value: true,
            type: "aadhaar",
            ref_id: response.data.ref_id,
          });
        } else {
          dispatch(updateisVerifyTick(true));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          identityNumber: response.data.error,
        }));
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        identityNumber: error ? error.response.data.message: error.response.data.error,
      }));
      // console.log(error, "response from error-----------------" , error.response.data.message)
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormOnNext = (step) => {
    let formData = {
      email,
      first_name,
      last_name,
      password,
      referralCode,
      username: user_data.user_name,
      selectedCountry,
      mobile_no: user_data.mobile_no,
      identityNumber,
      con_password: user_data.con_password,
      dob: Dob,
      selectedSize,
      packageSelection,
      referredBy,
    };

    let valid = true;
    const newErrors = {};

    if (referralBlockingError) {
      newErrors.referredBy = referralBlockingError;
      valid = false;
    }

    // Step-specific validations
    if (step === 0) {
      // First name validation
      if (!formData.first_name.trim()) {
        newErrors.first_name = "Enter your First Name";
        valid = false;
      }
      // Last name validation
      if (!formData.last_name.trim()) {
        newErrors.last_name = "Enter your Last Name";
        valid = false;
      }
      // Username validation
      // if (!formData.username.trim()) {
      //   newErrors.username = "Enter your Profile / Username";
      //   valid = false;
      // } else if (formData.username.length < 3) {
      //   newErrors.username = "Minimum 3 characters allowed";
      //   valid = false;
      // } else if (formData.username.length > 12) {
      //   newErrors.username = "Maximum 12 characters allowed";
      //   valid = false;
      // }
      // mobile number validation
     if (!formData.selectedCountry) {
        newErrors.mobile_no = "Please select your country";
        valid = false;
      }
      else if (!formData.mobile_no.trim()) {
        newErrors.mobile_no = "Enter your Mobile Number";
        valid = false;
      } else {
        const mobileError = validateLocalMobile({
          mobile: formData.mobile_no,
          countryCode: formData.selectedCountry?.value,
          maxLength: formData.selectedCountry?.numberLength || numberLength || 15,
        });
        if (mobileError) {
          newErrors.mobile_no = mobileError;
          valid = false;
        }
      } 

      // Email validation
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // if (!formData.email.trim()) {
      //   newErrors.email = "Enter your Email address";
      //   valid = false;
      // } else 
      if (formData.email.trim()&&!emailPattern.test(formData.email)) {
        newErrors.email = "Please enter a valid Email address.";
        valid = false;
      }
    }

    if (step === 1) {
      // Mobile number validation
      // else {
        // Validation for other countries (minimum 5, maximum 15 digits)
        // if (formData.mobile_no.length < 6 || formData.mobile_no.length > 15) {
        //   newErrors.mobile_no = "Enter a valid Mobile Number";
        //   valid = false;
        // }
      // }

      // Check if country is selected
      if (!formData.selectedCountry || !formData.selectedCountry?.value) {
        newErrors.selectedCountry = "Please select a country";
        valid = false;
      }

      // Country selection and Date of Birth validation
      if (formData.selectedCountry?.value !== "IN" && !formData.dob) {
        newErrors.dob = "Enter your Date of Birth";
        valid = false;
      }

      // Identity number validation
      if (!user_data.isVerifyTick) {
        if (!formData.identityNumber.trim()) {
          newErrors.identityNumber = "Enter your Identity Number";
          valid = false;
        } else if (
          formData.selectedCountry?.value === "IN" &&
          formData.identityNumber.length !== 12
        ) {
          newErrors.identityNumber = "Enter a valid 12-digit Aadhaar Number";
          valid = false;
        } else {
          // If identity number is provided but not verified
          newErrors.identityNumber = "Please verify your Identity Number.";
          valid = false;
        }
      }
    } else if (step === 2) {
      // Password validation
      if (!formData.password.trim()) {
        newErrors.password = "Please enter your Password";
        valid = false;
      } else if (
        formData.password.length < 8 ||
        !/[A-Z]/.test(formData.password) ||
        !/[a-z]/.test(formData.password) ||
        !/\d/.test(formData.password) ||
        !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(formData.password)
      ) {
        newErrors.password =
          "The Password must be at least 8 characters long and contain uppercase, lowercase letters, special characters, and numbers.";
        valid = false;
      }

      // Confirm password validation
      if (!formData.con_password.trim()) {
        newErrors.con_password = "Please re-enter your Password";
        valid = false;
      } else if (formData.password !== formData.con_password) {
        newErrors.con_password = "Confirm Password does not match";
        valid = false;
      }
    } else if (step === 3) {
      if (!agree) {
        newErrors.checkbox = "Please agree to the terms and policy";
        valid = false;
      }
    }

    // console.log("Form data for validation:", formData, newErrors);
    newErrors.Dob = "";
    setErrors(newErrors);
    if (valid) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const validateForm = (formData) => {
    let valid = true;
    const newErrors = {};
    // console.log("????????????????????????/validation form")
    // First name validation
    if (!formData.selectedSize) {
      newErrors.selectedSize = "Please select a size";
      valid = false;
    }

    if (!formData.packageSelection) {
      newErrors.packageSelection =
        "Please select a package or combo option";
      valid = false;
    }

    const referralError = getReferralCodeError(formData.referralCode);
    if (referralError) {
      newErrors.referredBy = referralError;
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  useEffect(() => {
    dispatch(updateEmail(""));
    dispatch(updatePassword(""));
    dispatch(updateCountry(""));
    dispatch(updateIdentityNumber(""));
    dispatch(updateisVerifyTick(false))
    dispatch(updateDob(null));
  }, []);

  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      mobile_no: "",
      selectedCountry: "",
      identityNumber: "",
      dob: "",
    }));
  }, [selectedCountry]);

  const passwordVisible = {
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={handleTogglePasswordVisibility} edge="end">
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  };

  const handleKeyPress = (e, step) => {
    if (e.key === "Enter") {
      validateFormOnNext(step);
      // handleSummit();
    }
  };

  const homePage = () => {
    navigate("/");
  };

  // const handleGoogleSuccess = (credentialResponse) => {
  //     const details = jwtDecode(credentialResponse.credential);
  //     // console.log(details);
  //     const { given_name, family_name, email } = details;
  //     // Dispatch these details to update the Redux store or make an API call to register/login the user
  //     // console.log(given_name,family_name,email)
  //     dispatch(updateFirstName(given_name));
  //     dispatch(updateLastName(family_name));
  //     dispatch(updateEmail(email));

  //     // Redirect to the password page
  //     navigate("/");

  // };

  // const handleGoogleError = () => {
  //     // .log('Login Failed');
  // };

  const handleGoogleSuccess = async (credentialResponse) => {
    const details = jwtDecode(credentialResponse.credential);
    // console.log(details);
    const { given_name, family_name, email } = details;
    // console.log(given_name, family_name, email);

    const payload = {
      email: email,
      first_name: given_name,
      last_name: "family_name" in details ? family_name : "",
      referralcode: referralCode ? referralCode : "",
      is_active: true,
      registration_type: "google",
    };
    // console.log(payload)

    // console.log(given_name);
    // console.log(family_name);
    // console.log(email);

    setIsloading(true);
    try {
      const response = await CustomAxios.post(`signup/`, payload);
      setIsloading(false);

      if (response.data.message === "Registration Successful!") {
        const decode = jwtDecode(response.data.access_token);
        localStorage.setItem("address", JSON.stringify(response.data.add));
        localStorage.setItem("authtoken", response.data.access_token);
        localStorage.setItem("refreshToken", response.data.refresh_token);
        // console.log(response.data.add);
        // console.log(decode);
        localStorage.setItem("user", JSON.stringify (response.data));
        dispatch(updateMemberResponse(response.data));
        dispatch(updateFirstName(decode.first_name));
        dispatch(updateLastName(decode.last_name));
        dispatch(updateEmail(decode.email));
        dispatch(updateRole(decode.role));
        dispatch(updateConrtol(decode.control))
        dispatch(updateCountry(decode.selectedCountry));
        dispatch(updateIdentityNumber(decode.identityNumber));
        dispatch(updateId(decode.id));
        dispatch(updateId(decode.id));
        if (response.data.att.length > 0) {
          dispatch(updateProfile(response.data.att[0].original));
        }
        dispatch(updateEmail(decode.email));
        navigate("/");
      } else {
        setErrors({ passworderror: response.data.message });
      }
    } catch (error) {
      setIsloading(false);
      // console.error(error);
    }
  };

  let signup_steps = [
    <TranslateText sx={{ fontSize: "12px" }}>Basic info</TranslateText>,
    <TranslateText sx={{ fontSize: "12px" }}>Package & Payment</TranslateText>,
    <TranslateText sx={{ fontSize: "12px" }}>Terms of Service</TranslateText>,
    <TranslateText sx={{ fontSize: "12px" }}>OTP Verification</TranslateText>,
  ];
  const [active_step, setActiveStep] = useState(0);
  const referralBlockingError = errors.referredBy || getReferralCodeError(referredBy);
  const isNextBlockedByReferral = active_step < 2 && (isReferralValidating || Boolean(referralBlockingError));

  const StepperConnector_styles = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: "12px",
      left: "calc(-50% + 20px)",
      right: "calc(50% + 20px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#53AEFF",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#53AEFF",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#D6DAE2",
      borderTopWidth: 2,
      borderRadius: 1,
    },
  }));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        handleTooltipClose();
      }
    };

    // Add event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [tooltipRef]);

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <>
        <Box
          component={isMobile ? "div" : Paper}
          elevation={isMobile ? undefined : 1}
          sx={{
            ...(isLaptop || isTablet
              ? {
                  left: "50%",
                  top: "50%",
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                }
              : {}),
            display: "flex",
            alignItems: { xs: "center", sm: "initial" },
            flexDirection: "column",
            width: { md: "750px", xs: "100%" },
            maxWidth: { sm: "440px", xs: "100%" },
            bgcolor: "#fff",
            borderRadius: { xs: "unset", sm: "12px" },
            overflow: "hidden",
          }}
        >
          {isMobile && (
            <Box
              src={background}
              sx={{
                width: { md: "40%", xs: "100%", sm: "40%" },
                height: { xs: "50vh", sm: "100vh", md: "auto" },
                maxheight: "80vh",
                overflowY: "scroll",
                backgroundSize: "auto",
                objectFit: "fill",
              }}
              component={"img"}
              alt="Signup"
            />
          )}
          <Stack
            sx={[
              {
                alignItems: "center",
                gap: { xs: "24px", md: "29px" },
                p: { xs: "16px", sm: "32px" },
                width: "100%",
                backgroundColor: "#fff",
              },
            ]}
          >
            <Stack sx={{ alignItems: "center" }}>
              <Box
                src={mayi_logo}
                component="img"
                sx={inputStyles.logo}
                onClick={homePage}
              />
              <TranslateText sx={inputStyles.subHeading} color="grey.900">
                Join us!
              </TranslateText>
              <TranslateText sx={inputStyles.content} color="grey.900">
                {" "}
                Create your account and start exploring.
              </TranslateText>
            </Stack>
            {/* <Box sx={{alignSelf:"start"}}>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={member}
                            onChange={(e)=>dispatch(updateMembership(e.target.value))}
                            >
                             <Tooltip PopperProps={{  sx: {"& .MuiTooltip-tooltip": { backgroundColor: "#001F38",  color: "#fff",  }, "& .MuiTooltip-arrow": { color: "#001F38",   }, },   }} title={  <Box ref={tooltipRef}  sx={{ backgroundColor: "#001F38", color: "white",  fontSize: "12px", textAlign: "center", padding: "8px", borderRadius: "4px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", maxWidth: "240px",}} ><TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} >MAYI IQ Member:</TranslateText>  <TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} > Unlock earning opportunities and special offers. Need to complete KYC verification.    </TranslateText>   </Box>}arrow open={openMember} onOpen={memberTooltip} onClose={memberTooltipClose}  placement="bottom" >
                            <FormControlLabel value="member" control={<Radio />} label={<TranslateText>Member</TranslateText>} />
                            </Tooltip>
                            <Tooltip PopperProps={{  sx: {"& .MuiTooltip-tooltip": { backgroundColor: "#001F38",  color: "#fff",  }, "& .MuiTooltip-arrow": { color: "#001F38",   }, },   }} title={  <Box ref={tooltipRef}  sx={{ backgroundColor: "#001F38", color: "white",  fontSize: "12px", textAlign: "center", padding: "8px", borderRadius: "4px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", maxWidth: "240px",}} ><TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} >MAYI IQ Basic user:</TranslateText>  <TranslateText sx={{ fontSize: "12px",     color: "white",     textAlign: "left",    }} >This option is for casual users who want to explore the platform. No KYC is required.    </TranslateText>   </Box>}arrow open={openNonMember} onOpen={nonMemberTooltip} onClose={nonMemberTooltipClose}  placement="bottom" >
                            <FormControlLabel value="non_member" control={<Radio />} label={<TranslateText>Non Member</TranslateText>} />
                            </Tooltip>
                            
                            </RadioGroup>  
                        </Box> */}
            <Stepper
              sx={{ width: "100%" }}
              activeStep={active_step}
              alternativeLabel
              connector={<StepperConnector_styles />}
            >
              {signup_steps.map((label, l_id) => (
                <Step key={l_id}>
                  <StepLabel
                    sx={{
                      fontWeight: 400,
                      "& .MuiStepLabel-label": { mt: "4px !important" },
                      "& .Mui-active": { fontWeight: "700 ! important" },
                      "& .Mui-active MuiStepConnector-line": {
                        borderColor: "red",
                      },
                      fontSize: "12px",
                      lineHeight: "20px",
                      letterSpacing: "0.25px",
                      color: "#171C21",
                      textTransform: "capitalize",
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
            {active_step === 0 ? (
              <Stack sx={{ gap: "16px", width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Box>
                    <TranslateText sx={inputStyles.label} color="grey.700">
                      First Name <span style={{ color: "red" }}>*</span>
                    </TranslateText>
                    <InputBase
                      autoFocus
                      autoComplete="given-name"
                      value={first_name}
                      sx={inputStyles.inputBase}
                      placeholder="Enter your First Name"
                      onKeyDown={(e) => handleKeyPress(e, active_step)}
                      onChange={(e) =>
                        dispatch(updateFirstName(e.target.value))
                      }
                    />
                    {errors.first_name && (
                      <TranslateText
                        sx={{
                          mt: "4px",
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "error.light",
                        }}
                      >
                        {errors.first_name}
                      </TranslateText>
                    )}
                  </Box>
                  <Box>
                    <TranslateText sx={inputStyles.label} color="grey.700">
                      Last Name <span style={{ color: "red" }}>*</span>
                    </TranslateText>
                    <InputBase
                      autoComplete="family-name"
                      value={last_name}
                      sx={inputStyles.inputBase}
                      placeholder="Enter your Last Name"
                      onKeyDown={(e) => handleKeyPress(e, active_step)}
                      onChange={(e) => dispatch(updateLastName(e.target.value))}
                    />
                    {errors.last_name && (
                      <TranslateText
                        sx={{
                          mt: "4px",
                          fontWeight: 400,
                          fontSize: "14px",
                          color: "error.light",
                        }}
                      >
                        {errors.last_name}
                      </TranslateText>
                    )}
                  </Box>
                </Box>
                {/* <Box>
                  <TranslateText sx={inputStyles.label} color="grey.700">
                    Profile / Username <span style={{ color: "red" }}>*</span>
                  </TranslateText>
                  <InputBase
                    autoComplete="member_username"
                    value={user_data.user_name}
                    sx={inputStyles.inputBase}
                    placeholder="Set Profile / Username"
                    onKeyDown={(e) => handleKeyPress(e, active_step)}
                    onChange={(e) =>
                      dispatch(
                        updateUserData({
                          type: "user_name",
                          data: e.target.value.replace(" ", ""),
                        })
                      )
                    }
                  />
                  {errors.username && (
                    <TranslateText
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "error.light",
                        mt: "4px",
                      }}
                    >
                      {errors.username}
                    </TranslateText>
                  )}
                </Box> */}
                <Box >

                
                <Box sx={{display:"flex",gap:"8px",flexDirection:{xs:"column",sm:"row"},width:"100%"}}>
                            <Box
                  // sx={{
                  //   display: "flex",
                  //   gap: "16px",
                  //   flexDirection: { xs: "column", sm: "row" },
                  // }}
                >
                  <TranslateText sx={inputStyles.label} color="grey.700">
                    Country <span style={{ color: "red" }}>*</span>
                  </TranslateText>
                  <Autocomplete
                     sx={{ padding: "0px" ,height:"48px"}}
                     style={{ width: "100%" ,maxWidth:"150px",height:"48px"}}
                     options={countries}
                     getOptionLabel={(option) => option.label}
                     filterOptions={(options, { inputValue }) => {
                      return options.filter(
                        (item) =>
                          item.dialCode?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                          item.label?.toLowerCase().includes(inputValue?.toLowerCase()) ||
                          item.code?.toLowerCase().includes(inputValue?.toLowerCase())
                      );
                    }}

                    onChange={handleCountryChange}
                    value={selectedCountry || null}
                    isOptionEqualToValue={(option, value) =>
                      value ? option?.value === value?.value : false
                    } // Check for null value
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                      <Box
                        key={key}
                        {...optionProps}
                        sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                      >
                        <img
                          src={option.flag}
                          alt={option.label}
                          style={{
                            width: "20px",
                            borderRadius:"2px"
                          }}
                        />
                        <Typography>{option.label}</Typography>
                      </Box>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        sx={{ height: "48px" }}
                        {...params}
                        placeholder="Search country..."
                        variant="outlined"
                      />
                    )}
                  />
                  {errors?.selectedCountry && (
                  <TranslateText
                    sx={{
                      mt: "4px",
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "error.light",
                      alignSelf: "flex-start",
                      // background: "red",
                    }}
                  >
                    {errors?.selectedCountry}
                  </TranslateText>
                )}
                </Box>
                
                <Box>
                    <TranslateText sx={inputStyles.label}>
                        Mobile Number <span style={{ color: "red" }}>*</span>
                    </TranslateText>
                    <InputBase autoComplete="tel-national" value={user_data.mobile_no}  onChange={(e) =>{ const maxLength = selectedCountry?.numberLength || numberLength || 15; const cleanedValue = normalizePhoneDigits(e.target.value).slice(0, maxLength); dispatch(updateMobile(cleanedValue)); }} sx={inputStyles.inputBase} startAdornment={selectedCountry&&<Typography sx={{marginRight:"15px"}}>{selectedCountry.dialCode}</Typography>}  inputProps={{ maxLength: selectedCountry?.numberLength || numberLength || 15, inputMode: "numeric", pattern: "[0-9]*" }} placeholder="Enter your mobile number" />   
                </Box>

                </Box> 
                {errors.mobile_no && (
                        <TranslateText sx={{  mt: "4px",fontWeight: 400,  fontSize: "14px", color: "error.light",  }}   > {errors.mobile_no}   </TranslateText>  )}
                        <Box sx={{ display: "inline" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checked || selectedCountry?.value !== "IN"}
                            onChange={handleCheckboxChange}
                            disabled={selectedCountry?.value !== "IN"}
                            sx={{
                              color:
                                selectedCountry?.value !== "IN"
                                  ? "grey.300"
                                  : "primary.light", // Change color based on the selected country
                              "&.Mui-checked": {
                                color: "primary.light",
                              },
                              "&.Mui-disabled": {
                                color: "grey.300", // Lighter color when disabled
                              },
                            }}
                          />
                        }
                        label={
                          <TranslateText
                            sx={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "grey.900",
                              textAlign: "left",
                            }}
                          >
                            Get updates / OTP via WhatsApp{" "}
                          </TranslateText>
                        }
                      />
                    </Box>
                </Box>
                
                <Box>
                 
                  <TranslateText sx={inputStyles.label} color="grey.700">
                    Email ID (Optional)
                  </TranslateText>
                  <InputBase
                    autoFocus
                    autoComplete="email"
                    value={email}
                    sx={inputStyles.inputBase}
                    placeholder="Enter your Email ID"
                    onKeyDown={(e) => handleKeyPress(e, active_step)}
                    onChange={(e) => dispatch(updateEmail(e.target.value))}
                  />
                  {errors.email && (
                    <TranslateText
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "error.light",
                        mt: "4px",
                      }}
                    >
                      {errors.email}
                    </TranslateText>
                  )}
                </Box>
              </Stack>
            ) : active_step === 1 ? (
              <Stack sx={{ gap: "16px", width: "100%" }}>
                <Box>
                  <TranslateText sx={inputStyles.label} color="grey.700">
                    Select Package / Combo <span style={{ color: "red" }}>*</span>
                  </TranslateText>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={selectedSize}
                      sx={inputStyles.Select}
                      inputProps={{ "aria-label": "Select Package / Combo" }}
                      onChange={(e) =>
                        dispatch(
                          updateUserData({
                            type: "selectedSize",
                            data: e.target.value,
                          })
                        )
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Package / Combo
                      </MenuItem>
                      {sizeOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errors.selectedSize && (
                    <TranslateText
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "error.light",
                        mt: "4px",
                      }}
                    >
                      {errors.selectedSize}
                    </TranslateText>
                  )}
                </Box>

                <Box>
                  <TranslateText sx={inputStyles.label} color="grey.700">
                    Select Plan
                    <span style={{ color: "red" }}>*</span>
                  </TranslateText>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={packageSelection}
                      sx={inputStyles.Select}
                      inputProps={{ "aria-label": "Select Plan" }}
                      onChange={(e) =>
                        dispatch(
                          updateUserData({
                            type: "packageSelection",
                            data: e.target.value,
                          })
                        )
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Plan
                      </MenuItem>
                      {packageOptions.map((option, index) => (
                        <MenuItem key={option.id} value={option.id} disabled={index !== 0}>
                          <Box sx={{display:"flex",justifyContent:"space-between",width:"100%"}}><TranslateText>{option.name}</TranslateText><TranslateText>{ indianNumberFormat(parseFloat(CalculateProductPrice({authtoken:true,member:true,item:{product:option},lineStrike:false})),true)}</TranslateText></Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errors.packageSelection && (
                    <TranslateText
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "error.light",
                        mt: "4px",
                      }}
                    >
                      {errors.packageSelection}
                    </TranslateText>
                  )}
                </Box>

                <Box>
                  <TranslateText sx={inputStyles.label} color="grey.700">
                    Referred by <span style={{ color: "red" }}>*</span>
                  </TranslateText>
                  <InputBase
                    value={referredBy}
                    disabled
                    sx={inputStyles.inputBase}
                    placeholder="Enter reference"
                    onKeyDown={(e) => handleKeyPress(e, active_step)}
                    onChange={(e) =>
                      dispatch(
                        updateUserData({
                          type: "referredBy",
                          data: e.target.value,
                        })
                      )
                    }
                  />
                  {errors.referredBy && (
                    <TranslateText
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "error.light",
                        mt: "4px",
                      }}
                    >
                      {errors.referredBy}
                    </TranslateText>
                  )}
                </Box>
              </Stack>
            ) : active_step === 2 ? (
              <Stack sx={{ gap: "16px", width: "100%" }}>
                <TranslateText
                  sx={{ mt: "24px", mb: "16px", fontWeight: 400, fontSize: "14px", color: "grey.900", lineHeight: 1.8 }}
                >
                  Please  read and agree to our Terms
                  of Service and Privacy Policy to continue with Registration.
                </TranslateText>
                <Button
                  variant="outlined"
                  sx={{
                    mt: "16px",
                    mb: "16px",
                    ...inputStyles.button,
                    borderRadius: "8px",
                    width: "100%",
                    textTransform: "none",
                  }}
                  onClick={() => setTermsModalOpen(true)}
                >
                  <TranslateText>Terms of Service &amp; Privacy Policy</TranslateText>
                </Button>
                {signupTermsAccepted && (
                  <TranslateText sx={{ fontSize: "14px", color: "success.main",mb:"16px" }}>
                    You have accepted the terms. Tap Next to continue to OTP verification.
                  </TranslateText>
                )}
                <Dialog
                  open={termsModalOpen}
                  onClose={() => setTermsModalOpen(false)}
                  maxWidth="sm"
                  fullWidth
                  scroll="paper"
                >
                  <DialogTitle>
                    <TranslateText sx={{ fontWeight: 700, fontSize: "18px" }}>
                      Terms of Service &amp; Privacy Policy
                    </TranslateText>
                  </DialogTitle>
                  <DialogContent dividers sx={{ maxHeight: "60vh" }}>
                    <Typography component="div" variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-line", lineHeight: 1.7 }}>
                      <TranslateText sx={{ display: "block", mb: 1, whiteSpace: "pre-wrap" }}>
                        {`By registering for the Mayi Global Holistic Wellness Social Enterprise Movement, you agree to the following:

Data Usage: Your name, email, and mobile number will be used solely for account verification, course updates, and essential communication via WhatsApp and Email.

Membership Access: Access to the Nature, Self, and Humanity video packages is granted upon successful payment. Sharing account credentials with third parties is prohibited.

Refund Policy: Subscriptions and digital course access are generally non-refundable once the content has been accessed.

Professional Conduct: Users are expected to maintain a respectful environment within any community forums or live sessions associated with the movement.

Privacy: We do not sell your personal data to third parties. All payment processing is handled via secure, encrypted gateways (Stripe).`}
                      </TranslateText>
                    </Typography>
                  </DialogContent>
                  <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button variant="outlined" onClick={() => setTermsModalOpen(false)}>
                      <TranslateText>Close</TranslateText>
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleSignupTermsAgree}
                      disabled={signupTermsAccepted}
                    >
                      <TranslateText>{signupTermsAccepted ? "Agreed" : "I agree"}</TranslateText>
                    </Button>
                  </DialogActions>
                </Dialog>
              </Stack>
            ) : active_step === 3 ? (
              <Box>
                <OtpVerifyOption
                  switchOTP={switchOTP}
                  onGenerateSignupOtp={signup}
                  signupOtpRequested={signupOtpRequested}
                />
              </Box>
            ) : null}
              {response && <TranslateText sx={{ fontSize: "14px", color: "error.light" }}>{response}</TranslateText>}
            <Stack sx={{ gap: "20px", width: "100%" }}>
              {active_step >= 0 ? (
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  sx={{ justifyContent: "space-between", gap: "20px" }}
                >
                 {active_step!=0 && <Button
                    variant="outlined"
                    sx={{
                      ...inputStyles.button,
                      borderRadius: "8px",
                      width: { xs: "100%", sm: "178px" },
                      height: "40px",
                      "&:hover": { bgcolor: "unset" },
                      textTransform: "capitalize",
                    }}
                    onClick={() => {
                      setActiveStep(active_step - 1);
                      setSwitchOTP(false);
                      if (active_step === 3) {
                        setSignupOtpRequested(false);
                      }
                    }}
                  >
                   <TranslateText>Previous</TranslateText> 
                  </Button>}
                  {active_step >= 3 ? (
                    <Button
                      variant="contained"
                      disabled={isNextBlockedByReferral || !signupOtpRequested}
                      sx={{
                        ...inputStyles.button,
                        width: { xs: "100%", sm: "178px" },
                        height: "40px",
                        borderRadius: "8px",
                        color:"#000",
                        "&:hover": {color:"#000" },
                      }}
                      onClick={()=>{setSwitchOTP(!switchOTP)}}
                    >
                      {isloading ? (
                        <CircularProgress color="inherit" size={30} />
                      ) : (
                        <TranslateText>Verify OTP</TranslateText>
                      )}
                    </Button>
                  ) : active_step === 2 ? (
                    <Button
                      variant="contained"
                      disabled={isNextBlockedByReferral || !signupTermsAccepted}
                      sx={{
                        ...inputStyles.button,
                        width: { xs: "100%", sm: "178px" },
                        height: "40px",
                        borderRadius: "8px",
                        color: "#000",
                        "&:hover": { color: "#000" },
                        "&.Mui-disabled": {
                          bgcolor: "#E2E8F0",
                          color: "#94A3B8",
                          cursor: "not-allowed",
                        },
                      }}
                      onClick={() => setActiveStep(3)}
                    >
                      <TranslateText>Next</TranslateText>
                    </Button>
                  ) : (
	                    <Button
	                      variant="contained"
		                      disabled={isNextBlockedByReferral}
		                      sx={{
	                        ...inputStyles.button,
	                        width: { xs: "100%", sm: active_step<1?"100%":"178px" },
	                        height: "40px",
	                        borderRadius: "8px",  
	                        color:"#000",
	                        "&:hover": {color:"#000" },
	                        "&.Mui-disabled": {
	                          bgcolor: "#E2E8F0",
	                          color: "#94A3B8",
	                          cursor: "not-allowed",
	                        },
	                      }}
                      onClick={() => active_step <1 ?
                        validateFormOnNext(active_step):handleSummit()}
                      
                      
                    >
		                      {isloading || isReferralValidating ? <CircularProgress color="inherit" size={30} /> :
		                      <TranslateText>Next</TranslateText>}
		                    </Button>
                  )}
                </Stack>
              ) : (
	                <Button
	                  variant="contained"
	                  disabled={isNextBlockedByReferral}
	                  sx={{
	                    ...inputStyles.button,
	                    height: "40px",
	                    borderRadius: "8px",  
	                    color:"#000",
	                    "&:hover": {color:"#000" },
	                    "&.Mui-disabled": {
	                      bgcolor: "#E2E8F0",
	                      color: "#94A3B8",
	                      cursor: "not-allowed",
	                    },
	                  }}
                  fullWidth
                  onClick={() => 
                     active_step <1 ?
                    validateFormOnNext(active_step):handleSummit()}
                  
                >
	                  {isloading || isReferralValidating ? <CircularProgress color="inherit" size={30} /> :
	                  <TranslateText>Next</TranslateText>}
	                </Button>
              )}
              {/* <Divider sx={{ fontSize: "14px", fontFamily:"Roboto" }} >Or</Divider> */}
              {/* <Box sx={{ display: 'flex', flexDirection:"column", justifyContent: "center"}}> */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                {/* <GoogleLogin
                                        onSuccess={handleGoogleSuccess}
                                        // onError={handleGoogleError}
                                    /> */}
                <Stack direction="row">
                  <TranslateText sx={{ textAlign: "center", fontSize: "14px" }}>
                    {" "}
                    Already have an account?&nbsp;
                  </TranslateText>
                  <Link
                    to="/login"
                    style={{
                      textDecoration: "none",
                      textDecorationLine: "underline",
                      fontSize: "14px",
                    }}
                  >
                    <TranslateText
                      sx={{ textDecoration: "none", fontSize: "14px" }}
                      color="primary"
                    >
                      Sign in
                    </TranslateText>
                  </Link>
                </Stack>
              </Box>
              {/* </Box> */}
            </Stack>
          </Stack>

          {/* <Box sx={{ padding: { sm: "32px "32px" }, display: "flex", alignItems: 'center', justifyContent: "center", flexDirection: 'column', bgcolor: "#fff", width: { sm: "60%", xs: "100%" } }}>
                        <Box sx={{ display: "flex", flexDirection: 'column', gap: "16px", width: "100%" }}> */}
          {/* <Box sx={{ display: "flex", gap: "16px", flexDirection: { xs: "column", sm: "row" } }}>
                                <Box>
                                    <TranslateText sx={inputStyles.label} color="grey.700">First Name <span style={{ color: "red" }}>*</span></TranslateText>
                                    <InputBase sx={inputStyles.inputBase} placeholder="Enter your First Name" onKeyDown={handleKeyPress} onChange={(e) => dispatch(updateFirstName(e.target.value))} />
                                    {errors.first_name && <TranslateText sx={{ fontWeight: 400, fontSize: "14px", color: "error.light", marginBottom: "-20px" }}>{errors.first_name}</TranslateText>}
                                </Box>
                                <Box>
                                    <TranslateText sx={inputStyles.label} color="grey.700">Last Name <span style={{ color: "red" }}>*</span></TranslateText>
                                    <InputBase sx={inputStyles.inputBase} placeholder="Enter your Last Name" onKeyDown={handleKeyPress} onChange={(e) => dispatch(updateLastName(e.target.value))} />
                                    {errors.last_name && <TranslateText sx={{ fontWeight: 400, fontSize: "14px", color: "error.light", marginBottom: "-20px" }}>{errors.last_name}</TranslateText>}
                                </Box>
                            </Box> */}
          {/* <Box>
                                <TranslateText sx={inputStyles.label} color="grey.700">Email <span style={{ color: "red" }}>*</span></TranslateText>
                                <InputBase sx={inputStyles.inputBase} placeholder="Enter email address" onKeyDown={handleKeyPress} onChange={(e) => dispatch(updateEmail(e.target.value))} />
                                {errors.email && <TranslateText sx={{ fontWeight: 400, fontSize: "14px", color: "error.light", marginBottom: "-20px" }}>{errors.email}</TranslateText>}
                            </Box>
                            <Box>
                                <TranslateText sx={inputStyles.label} color="grey.700">Password <span style={{ color: "red" }}>*</span></TranslateText>
                                <InputBase type={showPassword ? 'text' : 'password'} placeholder="Enter password" sx={inputStyles.inputBase} onKeyDown={handleKeyPress} onChange={(e) => dispatch(updatePassword(e.target.value))} endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                } />
                                {errors.password && <TranslateText sx={{ fontWeight: 400, fontSize: "14px", color: "error.light", marginBottom: "-20px" }}>{errors.password}</TranslateText>}
                            </Box>
                            <Box>
                                <TranslateText sx={inputStyles.label} color="grey.700">Sponsor Referral Code</TranslateText>
                                <InputBase sx={inputStyles.inputBase} value={referralCode} placeholder="Enter Referral Code" onKeyDown={handleKeyPress} onChange={(e) => setReferralCode(e.target.value)} />
                                {errors.referralCode && <TranslateText sx={{ fontWeight: 400, fontSize: "14px", color: "error.light", marginBottom: "-20px" }}>{errors.referralCode}</TranslateText>}
                            </Box>
                            <Box>
                                <Box sx={{ display: "flex", alignItems: "center", }}>
                                    <Checkbox
                                        checked={agree}
                                        onChange={() => setAgree(!agree)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                    <TranslateText sx={inputStyles.terms} ><a href="https://mayiiq.com/terms-of-services/" style={{ textDecoration: "none", color: "primary.light", fontWeight: "400", textDecorationLine: "underline" }} >Terms&nbsp;of&nbsp;Services</a >&nbsp;and&nbsp;<a style={{ textDecoration: "none", color: "primary.light", fontWeight: "400", textDecorationLine: "underline" }} href="https://mayiiq.com/privacy-policy/">Privacy Policy</a></TranslateText>
                                </Box>
                                {errors.checkbox && <TranslateText sx={{ fontWeight: 400, fontSize: "14px", color: "error.light", marginBottom: "-20px" }}>{errors.checkbox}</TranslateText>}
                            </Box>
                            <TranslateText sx={{ color: "error.light" }}>{response}</TranslateText>
                            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                <Button variant="contained" sx={inputStyles.button} onClick={handleSummit} >{isloading ? <CircularProgress color="inherit" size={30} /> : "Sign up"}</Button>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: "center" }}>
                                <TranslateText sx={{ textAlign: "center", fontSize: "14px" }}> Already have an account?&nbsp;</TranslateText><Link to="/login" style={{ textDecoration: "none", textDecorationLine: "underline", fontSize: "14px" }}><TranslateText sx={{ textDecoration: "none", fontSize: "14px" }} color="primary">Sign in</TranslateText></Link>
                            </Box>
                            <Divider sx={{ marginTop: "24px", marginBottom: "20px", fontSize: "14px" }} >Or</Divider>
                            <Box sx={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
                                <GoogleLogin
                                    onSuccess={handleGoogleSuccess}
                                    // onError={handleGoogleError}
                                />
                            </Box> */}
          {/* <Divider sx={{ marginTop: "24px", marginBottom: "20px", fontSize: "14px" }} >Or</Divider> */}
          {/* </Box>
                    </Box> */}
        </Box>
      </>
    </GoogleOAuthProvider>
  );
};
export default SignupStepperForm;
